import { getPath } from '@/router/common'

const baseUrl = {
  title: '财务准备',
  path: 'CCAccBaseInfo'
}

export default [
  {
    path: getPath('PaymentMethod', baseUrl),
    name: 'CCAccBaseInfo_PaymentMethod',
    component: () => import(/* webpackChunkName: "CCAccBaseInfo_PaymentMethod" */ '@/views/cCAccBaseInfo/paymentMethod/index.vue'),
    meta: {
      title: '支付方式'
    }
  },
  {
    path: getPath('BanckCardInfo', baseUrl),
    name: 'BanckCardInfo',
    component: () => import(/* webpackChunkName: "BanckCardInfo" */ '@/views/cCAccBaseInfo/banckCardInfo/index.vue'),
    meta: {
      title: '银行卡信息'
    }
  },
  {
    path: getPath('B_ACCOUNT_CN_BILLTYPE', baseUrl),
    name: 'CCAccBaseInfo_B_ACCOUNT_CN_BILLTYPE',
    component: () => import(/* webpackChunkName: "CCAccBaseInfo_B_ACCOUNT_CN_BILLTYPE" */ '@/views/cCAccBaseInfo/b_ACCOUNT_CN_BILLTYPE/index.vue'),
    meta: {
      title: '去向及结算方式'
    }
  },
  {
    path: getPath('b_dj_content', baseUrl),
    name: 'CCAccBaseInfo_b_dj_content',
    component: () => import(/* webpackChunkName: "CCAccBaseInfo_b_dj_content" */ '@/views/cCAccBaseInfo/b_dj_content/index.vue'),
    meta: {
      title: '定义摘要'
    }
  },
  {
    path: getPath('WriteOffSubject', baseUrl),
    name: 'CCAccBaseInfo_WriteOffSubject',
    component: () => import(/* webpackChunkName: "CCAccBaseInfo_WriteOffSubject" */ '@/views/cCAccBaseInfo/writeOffSubject/index.vue'),
    meta: {
      title: '科目核销对应'
    }
  },
  {
    path: getPath('AccountDefinition', baseUrl),
    name: 'CCAccBaseInfo_AccountDefinition',
    component: () => import(/* webpackChunkName: "CCAccBaseInfo_AccountDefinition" */ '@/views/cCAccBaseInfo/accountDefinition/index.vue'),
    meta: {
      title: '科目定义'
    }
  },
  {
    path: getPath('b_dj_contentAdd', baseUrl),
    name: 'b_dj_contentAdd',
    component: () => import(/* webpackChunkName: "b_dj_contentAdd" */ '@/views/cCAccBaseInfo/b_dj_contentAdd/index.vue'),
    meta: {
      title: '摘要定义'
    }
  },
  {
    path: getPath('BanckAdd', baseUrl),
    name: 'BanckAdd',
    component: () => import(/* webpackChunkName: "BanckAdd" */ '@/views/cCAccBaseInfo/banckAdd/index.vue'),
    meta: {
      title: '新增修改银行信息'
    }
  },
  {
    path: getPath('paytypeaddOrEdit', baseUrl),
    name: 'cCAccBaseInfo_paytypeaddOrEdit',
    component: () => import(/* webpackChunkName: "cCAccBaseInfo_paytypeaddOrEdit" */ '@/views/cCAccBaseInfo/paytypeaddOrEdit/index.vue'),
    meta: {
      title: '新增修改支付方式信息'
    }
  },
]
